import { render, staticRenderFns } from "./WhatsappBIcon.vue?vue&type=template&id=510383a7&scoped=true"
import script from "./WhatsappBIcon.vue?vue&type=script&lang=js"
export * from "./WhatsappBIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510383a7",
  null
  
)

export default component.exports